import type { HTTPValidationError } from '@/shared/generated'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { useMutation } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export function useSignOutMutation(
	options?: UseMutationOptions<void, AxiosError<HTTPValidationError>>
) {
	return useMutation<void, AxiosError<HTTPValidationError>>({
		mutationFn: () => client.auth.logoutAuthLogoutPost(),
		...(options || {}),
	})
}
